// ------------------------------------------------------------------
// BigLoads Owner Presell — SHARED WIRING.
//
// One hook that gives every layout variant IDENTICAL behavior:
//   - CTA link factories (list-free -> SignupPage, haul-star -> Subscription)
//   - GA4 presell_cta_click { variant, cta_type, cta_location } tracking
//   - Newsletter external link
// This keeps the A/B honest: only the visual LAYOUT differs, never the
// destinations or the analytics.
//
// CTA classes stay `.cta-list-free` / `.cta-haul-star` (Meta/GTM hooks).
// ------------------------------------------------------------------

import React from 'react';
import { NamedLink, ExternalLink } from '../../components';
import { trackGA4Event, GA4_EVENTS } from '../../analytics/ga4';
import { NEWSLETTER_URL } from './presellContent';

export const VARIANTS = ['rambo', 'grok', 'fable'];
export const DEFAULT_VARIANT = 'rambo';

export const normalizeVariant = v => (VARIANTS.includes(v) ? v : DEFAULT_VARIANT);

// Returns the CTA builders bound to a given variant for GA4 attribution.
export const usePresellCtas = variant => {
  // cta_type: list_free | haul_star | newsletter
  const track = (ctaType, location) => () => {
    trackGA4Event(GA4_EVENTS.PRESELL_CTA_CLICK, {
      variant,
      cta_type: ctaType,
      cta_location: location,
    });
  };

  // Owner signup flow -> plain /signup page (SignupPage). The userType
  // variant (/signup/owner) was not the desired UX.
  const listFreeLink = (className, location, children) => (
    <NamedLink className={className} name="SignupPage" onClick={track('list_free', location)}>
      {children}
    </NamedLink>
  );

  // Haul Star upgrade -> subscription checkout.
  const haulStarLink = (className, location, children) => (
    <NamedLink
      className={className}
      name="SubscriptionPage"
      onClick={track('haul_star', location)}
    >
      {children}
    </NamedLink>
  );

  const newsletterLink = (className, location, children) => (
    <ExternalLink
      href={NEWSLETTER_URL}
      className={className}
      onClick={track('newsletter', location)}
    >
      {children}
    </ExternalLink>
  );

  return { track, listFreeLink, haulStarLink, newsletterLink };
};
